import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Components
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
// Pages
import LandingPage from './pages/LandingPage/LandingPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import PhasePage from './pages/PhasePage/PhasePage';
import PhasePalLandingPage from './pages/PhasePalLandingPage/PhasePalLandingPage';
import TeamPage from './pages/TeamPage/TeamPage';
import Contact from './pages/ContactPage/Contact';
import SignUp from './pages/SignUpPage/SignUp';
import FAQPage from './pages/FAQPage/FAQPage';
import TermsOfService from './pages/Terms_of_Service/TermsOfService'
import PrivacyPolicy from './pages/Privacy_Policy/PrivacyPolicy'
import EndUserLicenseAgreement from './pages/End_User_License_Agreement/EndUserLicenseAgreement'

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main className="App-main">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/phase-fitness" element={<PhasePage />} />
            <Route path="/phase-pal" element={<PhasePalLandingPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/SignUp" element={<SignUp />} />
            <Route path="/FAQPage" element={<FAQPage />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/Privacy_Policy" element={<PrivacyPolicy />} />
            <Route path="/End_User_License_Agreement" element={<EndUserLicenseAgreement />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
